// NoteReminder.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { convertNumberToWords } from '../Utilities/Utilities';
import { post } from './Auths/AuthToken';
import setUiMessage from '../Utilities/Tostify';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../constents';
import { format } from 'date-fns';
import Button from './Button';
import { useSelector } from 'react-redux';

const OpenNoteAlertPopup = ({ cloase = () => {}, data = [] }) => {
  const [selectedNoteRemOpt, setSelectedNoteRemOpt] = useState('1');
  const [noteRemDateVisible, setNoteRemDateVisible] = useState(false);
  const [allData, setAllData] = useState(data);
  const [date, setDate] = useState('9');
  const [reminderDate, setReminderDate] = useState(new Date());
  const { user } = useSelector((store) => store.auth);
  const handleNoteDayChange = async (value) => {
    setDate(value);
    try {
      const response = await post(
        'api/appointment/Appointment/openNoteAlertPopup',
        { remType: 0, remDays: value, loginUserId: user?.id }
      );
      if (response.status === 200) {
        setAllData(response.data);
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleNoteRemOptChange = (value) => {
    setSelectedNoteRemOpt(value);
    if (value === '0') {
      setNoteRemDateVisible(true);
    } else {
      setNoteRemDateVisible(false);
    }
  };

  const saveNoteRemAlert = () => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/updateNoteAlert',
          {
            remOption: selectedNoteRemOpt,
            noteRemSelDate: reminderDate
              ? format(new Date(reminderDate), DEFAULT_DATE_FORMATE)
              : format(new Date(), DEFAULT_DATE_FORMATE),
            loginUserId: user?.id,
          }
        );
        if (response.status === 200) {
          cloase();
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  return (
    <div className="modalBackground">
      <div className="main-container-for-previous-visit single-visit-info-popup">
        <div
          className="flex-sec justify-between row-for-pre-all-visit item-center"
          style={{ height: 'unset', padding: '0 0 0 10px' }}
        >
          <div className="label-previous-visit  fontsize14">
            Reminder: Open notes
          </div>
          <Button
            variant="circle"
            onClick={() => {
              saveNoteRemAlert();
            }}
          >
            X
          </Button>
        </div>
        <div className="width100" style={{ borderBottom: '1px solid #dadada' }}>
          <div
            id="moteMsgBox"
            className="width100"
            style={{
              color: 'orange',
              margin: '20px 0',
              textAlign: 'center',
              fontSize: '21px',
            }}
          >
            {(() => {
              if (
                allData?.openCount !== '0' &&
                allData?.coSignOpenCount !== '0'
              ) {
                return (
                  <div>
                    <div>
                      You have{' '}
                      <Link href="#">
                        {convertNumberToWords(allData?.openCount)}
                      </Link>{' '}
                      open notes{' '}
                    </div>
                    <div>
                      (
                      <span className="">
                        {convertNumberToWords(allData?.coSignOpenCount)}
                      </span>{' '}
                      notes for Co-Sign)
                    </div>
                  </div>
                );
              } else if (
                allData?.openCount !== '0' &&
                allData?.coSignOpenCount === '0'
              ) {
                return (
                  <span>
                    You have{' '}
                    <Link href="#">
                      {' '}
                      {convertNumberToWords(allData?.openCount)}
                    </Link>{' '}
                    open notes.
                  </span>
                );
              } else if (
                allData?.openCount === '0' &&
                allData?.coSignOpenCount !== '0'
              ) {
                return (
                  <span>
                    You have{' '}
                    <Link href="#">
                      {convertNumberToWords(allData?.coSignOpenCount)}
                    </Link>{' '}
                    notes for Co-Sign.
                  </span>
                );
              } else {
                return <span>No open notes.</span>;
              }
            })()}
          </div>
          <div className="width100 clear-top10 fontsize13 flex-container">
            {[
              { value: '9', label: 'Last 60 days' },
              { value: '1', label: "Today's visit" },
              { value: '2', label: 'This week' },
              { value: '3', label: 'Last week' },
              { value: '4', label: 'This month' },
              { value: '5', label: 'Last month' },
              { value: '6', label: 'Last two months' },
              { value: '7', label: 'All visits' },
            ].map((item, index) => (
              <span className="flex-item clear-left clear-right" key={index}>
                <input
                  type="radio"
                  name="noteDay"
                  value={item.value}
                  checked={date === item.value}
                  onChange={() => handleNoteDayChange(item.value)}
                />
                <span className={item.value === date ? 'bold orange' : ''}>
                  {item.label}
                </span>
              </span>
            ))}
          </div>
          <div className="opn-nt-hdr" style={{ marginTop: '45px' }}>
            Remind me:
          </div>
          <div className="width100 clear-top10 fontsize13 med-label flex-container">
            {[
              { value: '1', label: 'Tomorrow' },
              { value: '7', label: 'After seven days' },
              { value: '30', label: 'After thirty days' },
              { value: '0', label: 'Select date' },
            ].map((item, index) => (
              <span
                className="flex-item  clear-left clear-right"
                style={{ width: '22%' }}
                key={index}
              >
                <input
                  className="clear-right"
                  type="radio"
                  name="noteRemOpt"
                  value={item.value}
                  checked={selectedNoteRemOpt === item.value}
                  onChange={() => handleNoteRemOptChange(item.value)}
                />
                <span className="med-value">{item.label}</span>
              </span>
            ))}
            {noteRemDateVisible && (
              <span id="noteRemBox" className="clear-left10 flex-container">
                <ReactDatePicker
                  selected={reminderDate || new Date()}
                  onChange={(date) => setReminderDate(date)}
                  // customInput={
                  //   <img
                  //     src={'./images/calendar-icon.png'}
                  //     alt="Calendar"
                  //     width={'30px'}
                  //   />
                  // } // Use the image as the custom input
                  dateFormat={DEFAULT_DATE_FORMATE}
                />
                {/* <img
                  className="ui-datepicker-trigger"
                  src="http://localhost/Medgre/images/calendar.gif"
                  alt="..."
                  title="..."
                /> */}
              </span>
            )}
          </div>
        </div>
        <div
          className="width100 clear5"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '5px 10px',
          }}
        >
          <Button
            variant="outline"
            onClick={() => {
              saveNoteRemAlert();
            }}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OpenNoteAlertPopup;
